<template>
  <v-card
    class="mx-auto"
    :border="border"
    mobile-break-point="1264"
    width="400"
    height="400"
    v-bind="props"
  >
    <v-img
      v-if="props.purpose.imageUrl"
      :src="props.purpose.imageUrl"
      height="40%"
      cover
    />
    <v-img
      v-else
      src="/public-portal/images/SailingPOV.jpg"
      height="40%"
      cover
    />
    <v-card-title class="text-h3"
      ><v-icon v-if="props.featured" color="info">mdi-star</v-icon>
      {{ props.name }}</v-card-title
    >
    <v-card-text
      v-if="props.purpose.portalDescription"
      class="overflow-hidden fill-height"
    >
      <p>{{ props.purpose.portalDescription }}</p>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions class="sticky-actions">
      <v-spacer></v-spacer>
      <router-link :to="{ name: 'donate', query: props.query }"
        ><v-btn color="primary">Donate to {{ name }}</v-btn></router-link
      >
    </v-card-actions>
  </v-card>
</template>
<script lang="ts" setup>
import type { DonationPurpose } from "@/composables/donations/useDonationNew";
import { LocationQueryRaw } from "vue-router";
const props = defineProps<{
  purpose: DonationPurpose;
  name: string;
  query: LocationQueryRaw;
  featured?: boolean;
}>();
const border = computed(() => (props.featured ? "xl info" : ""));
</script>
